import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { apiService } from '../services/api';
import LoadingSpinner from '../components/LoadingSpinner';

function Mading() {
    const [madingData, setMadingData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagination, setPagination] = useState(null);

    useEffect(() => {
        const fetchMading = async () => {
            try {
                setLoading(true);
                const response = await apiService.getMadingPaginated(currentPage);
                setMadingData(response.data.mading);
                setPagination(response.data.pagination);
                // log route response for debugging
                console.log('Mading API Response:', response.data);
                setLoading(false);
            } catch (err) {
                setError('Failed to load mading data');
                setLoading(false);
                console.error('Error fetching mading:', err);
            }
        };

        fetchMading();
    }, [currentPage]);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        window.scrollTo(0, 0);
    };

    if (loading) return <LoadingSpinner />;
    if (error) return <div className="text-center text-red-500 p-4">{error}</div>;
    if (!madingData) return <div className="text-center p-4">No mading data available</div>;

    return ( 
        <div className='min-h-screen bg-gray-100 lg:pt-24 pt-24 justify-center'>
            <div className="max-w-4xl mx-auto text-center mb-12 lg:px-0 px-6">
                <h1 className="lg:text-4xl text-xl font-bold text-center my-2">
                    {madingData.MadingJudul}
                </h1>
                <p className="text-body max-w-3xl mx-auto">
                    {madingData.MadingDeskipsi}
                </p>
            </div>
            <div className="max-w-6xl mx-auto bg-white shadow-md rounded-lg lg:p-6 p-4 mb-8">
                <div className="grid lg:grid-cols-3 grid-cols-1 gap-6">
                    {(madingData?.MadingData?.length ?? 0) === 0 ? (
                        <div className="text-center col-span-3 text-gray-500 py-6">
                            Belum ada postingan mading.
                        </div>
                        ) : (
                        
                    (madingData.MadingData ?? [])
                        .filter(item => !item.deleted && item.publicationStatus === 'published')
                        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) // Sort by latest date
                        .map((item, index) => (
                            <Link 
                                key={item._id}
                                to={`/mading/${item.MadingDataSlug}`}
                                className='w-full'
                            >
                                <div className={`group w-xl h-xl p-4 rounded-lg border-2 border-teal-100 bg-gradient-to-br from-teal-50 shadow transition-all hover:-translate-y-2 hover:shadow-xl}`}>
                                    <div className='text-start'>
                                        {item.MadingDataImage && item.MadingDataImage.length > 0 && (
                                            <div className="lg:h-36 h-28 transition-all delay-100 group-hover:-translate-y-1">
                                                <img
                                                    src={item.MadingDataImage[0]}
                                                    alt={`${item.MadingDataJudul}`}
                                                    className='w-full h-full object-cover rounded-lg mb-4 transition-all delay-75 group-hover:drop-shadow-lg'
                                                />
                                            </div>
                                        )}
                                        <div className="lg:pt-2 pt-1">
                                            <div>
                                                <h3 className='font-bold text-sm'>{item.MadingDataJudul}</h3>
                                                <p className='text-xs'>Dibuat oleh {item.MadingDataPembuat}</p>
                                                <p className='text-xs'>
                                                    {/* {new Date(item.MadingDataTanggal).toLocaleDateString('id-ID')} */}
                                                    {item.createdAt ? new Date(item.createdAt).toLocaleString('id-ID', {
                                                        day: '2-digit',
                                                        month: '2-digit',
                                                        year: 'numeric',
                                                        hour: '2-digit',
                                                        minute: '2-digit',
                                                        second: '2-digit'
                                                    }) : '-'}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                    ))
                        )}
                </div>
            </div>

            {/* Pagination Controls */}
            {pagination && (
                <div className="flex justify-center gap-4 my-8">
                    <button
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={!pagination.hasPrevPage}
                        className={`px-4 py-2 rounded-md ${
                            pagination.hasPrevPage
                                ? 'bg-primary-600 text-white hover:bg-primary-700'
                                : 'bg-gray-300 cursor-not-allowed'
                        }`}
                    >
                        Previous
                    </button>
                    <span className="px-4 py-2">
                        Page {currentPage} of {pagination.totalPages}
                    </span>
                    <button
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={!pagination.hasNextPage}
                        className={`px-4 py-2 rounded-md ${
                            pagination.hasNextPage
                                ? 'bg-primary-600 text-white hover:bg-primary-700'
                                : 'bg-gray-300 cursor-not-allowed'
                        }`}
                    >
                        Next
                    </button>
                </div>
            )}
            <div className="flex justify-center my-6">
                <Link
                    to="/"
                    className="text-left px-3 py-2 rounded-md lg:text-base text-sm font-medium bg-primary-600 text-white hover:bg-primary-700 transition-colors flex items-center"
                >
                    🏠 Beranda
                </Link>
            </div>
        </div>
     );
}

export default Mading;